module.exports = __webpack_public_path__ + "img/127.7.392a33d7.png";